"use strict";var e=require("react");exports.useEffectOnce=r=>{e.useEffect(r,[])};
//# sourceMappingURL=useEffectOnce-BDX-lJSy.js.map
